export enum ActionStatus {
  BLOCKING = 'BLOCKING',
  UNBLOCKING = 'UNBLOCKING',
}

export enum CardBlockStatus {
  CardOk = 'Card OK',
  CardDoNotHonorWeb = 'Card Do not honor Web and Token to Suspend',
  CardDoNotHonorTax = 'Card Do not honor TAX and Token to Suspend',
  CardDoNotHonor = 'Card Do not honor and Token to Suspend',
}
export enum LimitCurrentStatus {
  Active = 'Active', //aktiv
  Suspended = 'Suspended', //deaktiv
  Override = 'Override', //teyin olunub
  InActive = 'InActive', // teyin olunmayib
}
export const statusStyles = {
  Active: { background: '#D4F4E2', color: '#299E5C', text: 'Active' },
  Suspended: {
    background: '#FBDDDD',
    color: '#E62929',
    text: 'Suspended',
  },
  Override: {
    background: '#DCE8FF',
    color: '#2979E6',
    text: 'Override',
  },
  InActive: {
    background: '#F8E6B1',
    color: '#A67C00',
    text: 'InActive',
  },
}
export const LIMIT_ATM = 'Limit_ATM';
export const DEACTIVE = 'Deactivate';
